<template>
  <li class="dropdown messages-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="triggerInfiniteBool = true">
      <i class="fa fa-bell-o"></i>
      <span class="label label-warning" v-show="headerNotiRequestTotal > 0">{{ numberFormat(headerNotiRequestTotal) }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="noti-header">
        <template v-if="headerNotiRequestTotal > 0">
          {{ labels[nowLang]['new_noti1'] }} {{ numberFormat(headerNotiRequestTotal) }} {{ labels[nowLang]['new_noti2'] }}
        </template>
        <template v-else>
          {{ labels[nowLang]['no_noti'] }}
        </template>
      </li>
      <li> 
        <!-- inner menu: contains the actual data -->
        <ul class="request-list">
          <li v-for="headerNotis in headerNotiRequestRows" class="request-box clearfix"><!-- start message -->
            <router-link :to="{ name: headerNotis.codapp.toLowerCase() }">
              <div class="request-icon-box">
                <i class="fa fa-bell-o" v-if="headerNotis.staappr == 'P'"></i>
                <i class="fa fa-bell-o" v-else-if="headerNotis.staappr == 'Y'"></i>
                <i class="fa fa-bell-o" v-else-if="headerNotis.staappr == 'N'"></i>
                <i class="fa fa-bell-o" v-else-if="headerNotis.staappr == 'A'"></i>
                <i class="fa fa-bell-o" v-else></i>
              </div>

              <div class="request-topic-box clearfix">
                <div class="request-topic">{{ headerNotis.descapp }}</div>
                <small><i class="fa fa-clock-o"></i> {{ setDateTimeRangeOutput(headerNotis.dtereq) }}</small>
                <div class="request-status">
                  <template v-if="headerNotis.staappr == 'P'">{{ labels[nowLang]['staappr_p'] }}</template>
                  <template v-else-if="headerNotis.staappr == 'Y'">{{ labels[nowLang]['staappr_y'] }}</template>
                  <template v-else-if="headerNotis.staappr == 'N'">{{ labels[nowLang]['staappr_n'] }}</template>
                  <template v-else-if="headerNotis.staappr == 'A'">{{ labels[nowLang]['staappr_a'] }}</template>
                </div>
                <div class="request-detail-box">
                  <template v-if="headerNotis.codapp == 'HRES32E'">
                    <b> {{ labels[nowLang]['hres32e_edit'] }} :</b> 
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '1'">{{ labels[nowLang]['hres32e_edit_1'] }}</template>
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '2'">{{ labels[nowLang]['hres32e_edit_2'] }}</template>
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '3'">{{ labels[nowLang]['hres32e_edit_3'] }}</template>
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '4'">{{ labels[nowLang]['hres32e_edit_4'] }}</template>
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '5'">{{ labels[nowLang]['hres32e_edit_5'] }}</template>
                    <template v-if="headerNotis.detail1.split('$##$')[0] == '6'">{{ labels[nowLang]['hres32e_edit_6'] }}</template>
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES34E'">
                    <b> {{ labels[nowLang]['hres34e_dtemov'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres34e_department'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                    <br><b> {{ labels[nowLang]['hres34e_location'] }} :</b> {{ headerNotis.detail1.split('$##$')[2] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES36E'">
                    <b> {{ labels[nowLang]['hres36e_refno'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES3BE'">
                    <b> {{ labels[nowLang]['hres3be_numcompl'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres3be_descompl'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES62E'">
                    <b> {{ labels[nowLang]['hres62e_dteleave'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres62e_desc'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES6AE'">
                    <b> {{ labels[nowLang]['hres6ae_dtereq'] }} :</b>
                     {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres6ae_codrem'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES6DE'">
                    <b> {{ labels[nowLang]['hres6de_dtework'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES6IE'">
                    <b> {{ labels[nowLang]['hres6ie_numcourse'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres6ie_location'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES6KE'">
                    <b> {{ labels[nowLang]['hres6ke_dtereq'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><div class="pull-left" style="margin-right:5px;"><b> {{ labels[nowLang]['hres6ke_timreq'] }} :</b></div>
                    <div class="pull-left"> {{ headerNotis.detail1.split('$##$')[1] }}&nbsp;&nbsp;{{ headerNotis.detail1.split('$##$')[2] }}&nbsp;&nbsp;{{ headerNotis.detail1.split('$##$')[3] }} </div>
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES6ME'">
                    <b> {{ labels[nowLang]['hres6me_dtereq'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres6me_codleave'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES71E'">
                    <b> {{ labels[nowLang]['hres71e_namsick'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres71e_amount'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES74E'">
                    <b> {{ labels[nowLang]['hres74e_nameobf'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres74e_amtreq'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES77E'">
                    <b> {{ labels[nowLang]['hres77e_codlon'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres77e_amtlonreq'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES81E'">
                    <b> {{ labels[nowLang]['hres81e_location'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres81e_dteeffec'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[1]) }}
                    <br><b> {{ labels[nowLang]['hres81e_cost'] }} :</b> {{ headerNotis.detail1.split('$##$')[2] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES86E'">
                    <b> {{ labels[nowLang]['hres86e_dteeffec'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres86e_codexemp'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES88E'">
                    <b> {{ labels[nowLang]['hres88e_department'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres88e_position'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES91E'">
                    <b> {{ labels[nowLang]['hres91e_codcours'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hres91e_year'] }} :</b> {{ setYearOutput(headerNotis.detail1.split('$##$')[1]) }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRES95E'">
                    <b> {{ labels[nowLang]['hres95e_dtechq'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[0]) }}
                    <br><b> {{ labels[nowLang]['hres95e_codidchq'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRESS2E'">
                    <b> {{ labels[nowLang]['hress2e_ratereta'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hress2e_codplan'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                  </template>
                  <template v-else-if="headerNotis.codapp == 'HRESS4E'">
                    <b> {{ labels[nowLang]['hress4e_department'] }} :</b> {{ headerNotis.detail1.split('$##$')[0] }}
                    <br><b> {{ labels[nowLang]['hress4e_position'] }} :</b> {{ headerNotis.detail1.split('$##$')[1] }}
                    <br><b> {{ labels[nowLang]['hress4e_dtestart'] }} :</b> {{ setDateTimeRangeOutput(headerNotis.detail1.split('$##$')[2]) }}
                  </template>
                </div>
              </div>
            </router-link>
          </li>
          <hrms-infinite-loading v-if="triggerInfiniteBool" @infinite="onInfinite" ref="headerNotiRequestLoading" />
          <!-- end message -->
        </ul>
      </li>
<!--       <li class="footer">
        <router-link :to="{ name: 'hrms14x' }">{{ labels[nowLang]['view_all'] }}</router-link>
      </li> -->
    </ul>
  </li>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'header-noti',
  props: [ 'headerNotiRequestTotal', 'headerNotiRequestInfiniteLoading', 'receivedHeaderNotiRequestInfiniteLoading', 'numberFormat', 'nowLang' ],
  data () {
    return {
      labels: {
        en: {
          'staappr_p': 'Pending',
          'staappr_a': 'Approving',
          'staappr_n': 'Refused',
          'staappr_y': 'Approved',
          'no_noti': 'You have no submitted requests.',
          'new_noti1': 'You have submitted',
          'new_noti2': 'requests.',
          'view_all': 'View all notifications.',
          'hres32e_edit': 'Edit',
          'hres32e_edit_1': 'Employee Name',
          'hres32e_edit_2': 'Personal Data',
          'hres32e_edit_3': 'Education information',
          'hres32e_edit_4': 'Child information',
          'hres32e_edit_5': 'Reward information',
          'hres32e_edit_6': 'Training information',
          'hres34e_dtemov': 'Effective Date',
          'hres34e_department': 'Department',
          'hres34e_location': 'New Location',
          'hres36e_refno': 'Certificate No.',
          'hres3be_numcompl': 'Complain No.',
          'hres3be_descompl': 'Description',
          'hres62e_dteleave': 'Leave Date',
          'hres62e_desc': 'Description',
          'hres6ae_dtereq': 'Request Date-Time',
          'hres6ae_codrem': 'Reason',
          'hres6de_dtework': 'Working Date',
          'hres6ie_numcourse': 'Course',
          'hres6ie_location': 'Location',
          'hres6ke_dtereq': 'Request Date',
          'hres6ke_timreq': 'Time',
          'hres6me_dtereq': 'Leave Date',
          'hres6me_codleave': 'Leave Code',
          'hres71e_namsick': 'Patient name',
          'hres71e_amount': 'Amount',
          'hres74e_nameobf': 'Requisition',
          'hres74e_amtreq': 'Price',
          'hres77e_codlon': 'Type of loan',
          'hres77e_amtlonreq': 'Amount',
          'hres81e_location': 'Location',
          'hres81e_dteeffec': 'Effective Date',
          'hres81e_cost': 'Cost',
          'hres86e_dteeffec': 'Effective Date',
          'hres86e_codexemp': 'Reason',
          'hres88e_department': 'Department',
          'hres88e_position': 'Position',
          'hres91e_codcours': 'Course',
          'hres91e_year': 'Year',
          'hres95e_dtechq': 'Change Date',
          'hres95e_codidchq': 'Exchange with',
          'hress2e_ratereta': 'Deduction Rate',
          'hress2e_codplan': 'Provident Fund Plan',
          'hress4e_department': 'Department',
          'hress4e_position': 'Position',
          'hress4e_dtestart': 'Start Working Date'
        },
        th: {
          'staappr_p': 'รอพิจารณา',
          'staappr_a': 'อยู่ระหว่างการอนุมัติ',
          'staappr_n': 'ไม่อนุมัติ',
          'staappr_y': 'อนุมัติแล้ว',
          'no_noti': 'คุณยังไม่มีการแจ้งเตือนใหม่',
          'new_noti1': 'คุณมีการแจ้งเตือนใหม่',
          'new_noti2': 'รายการ',
          'view_all': 'ดูรายการทั้งหมด',
          'hres32e_edit': 'แก้ไข',
          'hres32e_edit_1': 'ชื่อพนักงาน',
          'hres32e_edit_2': 'ข้อมูลส่วนตัว',
          'hres32e_edit_3': 'ข้อมูลการศึกษา',
          'hres32e_edit_4': 'ข้อมูลบุตร',
          'hres32e_edit_5': 'ข้อมูลคุณความดี',
          'hres32e_edit_6': 'ข้อมูลการฝึกอบรม',
          'hres34e_dtemov': 'วันที่ย้าย',
          'hres34e_department': 'หน่วยงาน',
          'hres34e_location': 'สถานที่ทำงานใหม่',
          'hres36e_refno': 'เลขที่ใบรับรอง',
          'hres3be_numcompl': 'เลขที่คำร้อง',
          'hres3be_descompl': 'รายละเอียด',
          'hres62e_dteleave': 'ช่วงวันที่ลา',
          'hres62e_desc': 'รายละเอียด',
          'hres6ae_dtereq': 'วัน-เวลาที่ขอแก้ไข',
          'hres6ae_codrem': 'สาเหตุการขอแก้ไข',
          'hres6de_dtework': 'วันที่ทำงาน',
          'hres6ie_numcourse': 'หลักสูตร',
          'hres6ie_location': 'สถานที่',
          'hres6ke_dtereq': 'วันที่ขอทำ OT',
          'hres6ke_timreq': 'เวลา',
          'hres6me_dtereq': 'ช่วงวันที่ลา',
          'hres6me_codleave': 'รหัสการลา',
          'hres71e_namsick': 'ชื่อคนไข้',
          'hres71e_amount': 'จำนวน',
          'hres74e_nameobf': 'ขอเบิก',
          'hres74e_amtreq': 'ราคา',
          'hres77e_codlon': 'ประเภทเงินกู้',
          'hres77e_amtlonreq': 'จำนวน',
          'hres81e_location': 'สถานที่',
          'hres81e_dteeffec': 'ช่วงเวลา',
          'hres81e_cost': 'ค่าใช้จ่าย',
          'hres86e_dteeffec': 'วันที่มีผลบังคับใช้',
          'hres86e_codexemp': 'สาเหตุ',
          'hres88e_department': 'หน่วยงาน',
          'hres88e_position': 'ตำแหน่ง',
          'hres91e_codcours': 'หลักสูตร',
          'hres91e_year': 'ปี',
          'hres95e_dtechq': 'วันที่ขอแลกกะ',
          'hres95e_codidchq': 'แลกกับ',
          'hress2e_ratereta': 'อัตราการหักเงินสะสม',
          'hress2e_codplan': 'แผนการลงทุน',
          'hress4e_department': 'หน่วยงาน',
          'hress4e_position': 'ตำแหน่ง',
          'hress4e_dtestart': 'วันที่เริ่มงาน'
        }
      },
      headerNotiRequestRows: [],
      page: 1,
      limit: 10,
      triggerInfiniteBool: false
    }
  },
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setDateRangeOutput (date) {
      return assetsUtils.getDateRangeOutput(date)
    },
    setDateTimeRangeOutput (date) {
      return assetsUtils.getDateTimeRangeOutput(date)
    },
    onInfinite ($state) {
      this.receivedHeaderNotiRequestInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        staappr: 'P,Y,N,A',
        searchParams: {
          p_page: this.page,
          p_limit: this.limit
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ data, $state }) {
      if (data.rows.length) {
        this.headerNotiRequestRows = this.headerNotiRequestRows.concat(data.rows)
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// HeaderRequest.vue?bc93c30a